<!-- Supplied Message -->
<div *ngIf="error && error.message && error.message != ''">{{ error.message }}</div>

<!-- Coded Messages -->
<div *ngIf="error && !(error.message == '') && error.code === 500" i18n="@@error_server_error">An error occured on the server</div>
<div *ngIf="error && !(error.message == '') && error.code === 503" i18n="@@error_service_unavailable">The server is not currently available</div>
<div *ngIf="error && !(error.message == '') && error.code === 1000" i18n="@@error_login_error">An error caused signin to fail</div>
<div *ngIf="error && !(error.message == '') && error.code === 2001" i18n="@@error_server_timeout">The server did not respond to the request</div>
<div *ngIf="error && !(error.message == '') && error.code === 9999" i18n="@@error_unknown">An unexpected error occured</div>
